import styled from "styled-components";
import CircleImg from "assets/images/circle.svg";
import { GlobalWrapper, TextWrapper } from "shared/Styles/Wrappers";

export const Container = styled(GlobalWrapper)`
  overflow: hidden;
  padding: 48px 0 96px 0;
  background-color: ${({ theme }) => theme.colors.gray_light};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding: 24px 0 72px 0;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 12px 0 0px 0;
  }
`;

export const Wrapper = styled(TextWrapper)`
  position: relative;
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.laptop_big}) {
    padding: 64px 0;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding-left: 24px;
    padding-right: 24px;
    &:before {
      display: none;
    }
  }
`;

export const TitleWrapper = styled.div`
  margin-bottom: 48px;
`;

export const ItemsWrapper = styled.div``;

export const Item = styled.div`
  padding: 36px 48px;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  &:not(:last-child) {
    margin-bottom: 24px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    flex-direction: column;
    padding: 24px 36px;
  }
`;

export const Number = styled.span`
  font-size: 48px;
  line-height: 1;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.purple};
  display: block;
  margin-right: 64px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 42px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    flex-direction: column;
    margin-right: 0;
    margin-bottom: 24px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    font-size: 28px;
    margin-bottom: 12px;
  }
`;

export const ItemTitle = styled.div`
  font-weight: 800;
  font-size: 22px;
  margin-bottom: 32px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 18px;
    margin-bottom: 24px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    font-size: 16px;
    margin-bottom: 18px;
  }
`;

export const StyledList = styled.ul``;

export const StyledListItem = styled.li`
  font-size: 18px;
  padding-left: 32px;
  position: relative;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 14px;
  }
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 6px;
    left: 0;
    width: 8px;
    height: 8px;
    background-image: url(${CircleImg});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  &:not(:last-child) {
    margin-bottom: 12px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 14px;
    padding-left: 24px;
    &:before {
      top: 4px;
      width: 6px;
      height: 6px;
    }
  }
`;

export const ListWrapper = styled.div``;
